import { container } from "tsyringe";

// 생각해보면 factory 내에서 store 를 생성하는것이 테스트에서 용이할지는 의문이 듭니다.
// store 하나하나 구현체로서 주입되는것이 아니라면 테스트에서 좀 더 어려울 수 있다는 판단입니다.
// 따라서 현재 stateRegister 내에서 모든 server State 를 따로 등록해주고
// 이에 대한 타입을 application 내에서 사용하도록 하겠습니다. (여기서도 정의합니다. 왜냐하면 UI 에서도 사용될 수 있으니)

// impl
import StoreManagerImpl from "@/shared/libs/state-management";

// stores
import useAlertStore from "@/shared/model/store/alert";
import useLoadingStore from "@/shared/model/store/loading";
import useModalStore from "@/shared/model/store/modal";
import useModalSecondLayerStore from "@/shared/model/store/modal-second-layer";

// types
import type { AlertState, ComponentPropsInAlert } from "@/shared/model/store/alert/interface";
import type { LoadingState } from "@/shared/model/store/loading/interface";
import type {
    ModalState,
    ComponentPropsInModal,
    ModalLayout,
} from "@/shared/model/store/modal/interface";
import type {
    ModalSecondLayerState,
    ComponentPropsInModalSecondLayer,
    ModalLayout as SecondModalLayout,
} from "@/shared/model/store/modal-second-layer/interface";

import type { ClientStateManager } from "@/shared/types/adapter/client-interface";

const clientStateRegisterInit = () => {
    container.register<ClientStateManager.AlertManager>("AlertManager", {
        useValue: new StoreManagerImpl<AlertState<keyof ComponentPropsInAlert>>(useAlertStore()),
    });
    container.register<ClientStateManager.LoadingManager>("LoadingManager", {
        useValue: new StoreManagerImpl<LoadingState>(useLoadingStore()),
    });
    container.register<ClientStateManager.ModalManager>("ModalManager", {
        useValue: new StoreManagerImpl<ModalState<keyof ComponentPropsInModal, ModalLayout>>(
            useModalStore(),
        ),
    });
    container.register<ClientStateManager.ModalSecondLayerManager>("ModalSecondLayerManager", {
        useValue: new StoreManagerImpl<
            ModalSecondLayerState<keyof ComponentPropsInModalSecondLayer, SecondModalLayout>
        >(useModalSecondLayerStore()),
    });
};

export default clientStateRegisterInit;
